import { combineReducers } from "redux";

import categoriesReducer from "./reducers/categoriesReducer";
import filterValuesReducer from "./reducers/filterValuesReducer";

export default () => combineReducers({
    categories: categoriesReducer,
    filterValues: filterValuesReducer,
});
